// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"673b993e","228":"afa64800","242":"882a4c7a","402":"93ee7f6e","613":"7e023820","822":"e3ab76b0","859":"848137e7"}[chunkId] + ".css";
};